<template>
    <div class="l-rblock l-form-viewer" style="padding:16px;" >
        <el-form
            ref="form"
            :model="formData"
            :rules="rules"

            :size="myFormInfo.size" 
            :labelPosition="myFormInfo.labelPosition"  
            :label-width="myFormInfo.labelWidth ? `${myFormInfo.labelWidth}px` : '80px'" >
            <input type="text" style="display:none">
            <div :class="['l-auto-window',{ 'only-tabs': showTabList.length <= 1}]" >
                <el-tabs  v-model="formActiveName" type="card" >
                    <el-tab-pane class="l-tabs-container" v-for="(item, index) in showTabList" :key="index"  :label="item.text" :name="'tab' + index">
                        <el-row :gutter="myFormInfo.gutter">
                            <div class="l-rblock" >
                                <template v-for="(col) in item.components" >
                                    <el-col 
                                        style="margin-bottom: 16px;"
                                        v-if="['gridtable'].includes(col.type)"
                                        :key="col.prop" 
                                        :span="24" >
                                        <div v-if="!$validatenull(col.label)" class="l-title" >{{$t(col.label)}}</div>
                                        <l-edit-table
                                            :required="col.required"
                                            :addBtnText="col.addBtnText"
                                            :isAddBtn="col.isAddBtn"
                                            :isRemoveBtn="col.isRemoveBtn"
                                            :isShowNum="col.isShowNum"

                                            :columns="getTableColumns(col.children)"
                                            :dataSource="formData[col.prop]"
                                            :filterDeleteBtn="filterTableDeleteBtn"

                                            @addRow="handleAddRow(col)"
                                            @deleteRow="handleDeleteRow($event,col)"

                                            :ref="col.prop"
                                        >
                                            <template v-for="(column) in col.children" v-slot:[column.prop]="scope" >
                                                <viewer-form-item :getShowText="getShowText" :changeDataEvent="col.changeDataEvent" :key="column.prop" v-model="scope.row[column.prop]" :row="scope.row" :data="column"></viewer-form-item>
                                            </template>
                                        </l-edit-table>
                                    </el-col>
                                    <el-col 
                                        style="margin-bottom: 16px;"
                                        v-else-if="['viewtable'].includes(col.type)"
                                        :key="col.prop"
                                        :span="24" >
                                        <div v-if="!$validatenull(col.label)" class="l-title" >{{$t(col.label)}}</div>
                                        <viewer-table
                                            :paramFiled="formData[col.paramFiled]"
                                            :data="col"
                                        >
                                        </viewer-table>
                                    </el-col>
                                    <el-col
                                        v-else-if="!['gridtable'].includes(col.type)"
                                        :key="col.prop" 
                                        :span="col.span" >
                                        <viewer-form-item v-if="col.type == 'divider'" :data="col"></viewer-form-item>
                                        <el-form-item 
                                            v-else
                                            v-show="col.display"
                                            :label="col.label"
                                            :labelWidth="col.labelWidth == undefined? undefined : col.labelWidth + 'px'"
                                            :prop="col.prop"
                                            >
                                            <viewer-form-item :changeDataEvent="myFormInfo.changeDataEvent" :getShowText="getShowText"  :setRequired="setRequired" :setDisabled="setDisabled" :components="components" :isForm="true" v-model="formData[col.prop]" :data="col" :formData="formData"></viewer-form-item>
                                        </el-form-item>
                                    </el-col>
                                </template>
                            </div>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-form>
    </div>
</template>

<script>
import viewerFormItem from './viewerFormItem'
import viewerTable from './viewerTable'
export default {
    name:'l-form-viewer',   
    components: {
        viewerFormItem,
        viewerTable
    },
    provide () {
        return {
            formViewer: this
        }
    },
    props: {
        formInfo:{
            type:Object,
            default:()=>{
                return {};
            }
        },
        isAuth:{
            type:Boolean,
            default:false
        },
        isRead:{
            type:Boolean,
            default:false
        }
    },
    data () {
        return {
            formActiveName:'tab0',
            formData:{},
            myFormInfo:{},

            oldFormData:null
        }
    },
    computed:{
        rules(){
            const res = {}
            this.myFormInfo.tabList && this.myFormInfo.tabList.forEach(tab=>{
                tab.components.forEach(component=>{
                    if(!['gridtable'].includes(component.type)){
                        if(component.required){
                            res[component.prop] = []
                            res[component.prop].push({ required: true, message: `请输入${component.label}`,trigger: 'blur' })
                        }
                        if(component.patterns && component.patterns.length > 0){
                            res[component.prop] = res[component.prop] || []
                            component.patterns.forEach(pattern =>{
                                res[component.prop].push({ pattern:eval(pattern.reg), message: pattern.msg,trigger: 'blur' })
                            })
                        }
                    }
                })
            })
            return res
        },
        tabList(){
            /**对表单字段调整根据权限信息 */
            if(this.isAuth && this.lr_pageAuthInfo && this.lr_pageAuthInfo.isAuth){
                const tabList = []

                const authData = this.lr_pageAuthInfo.data.forms
                const authMap = {}

                authData.forEach(item => {
                    const itemList = item.split(',')
                    const propList = itemList[0].split('|')
                    if(propList.length > 1){
                        // 表格
                        authMap[propList[0]] = authMap[propList[0]] || {}
                        authMap[propList[0]][propList[1]] = itemList[1]
                    }
                    else {
                        // 表单字段
                        authMap[itemList[0]] = itemList[1]
                    }
                })

                // 放置隐藏组件
                const hideComponents = []
                
                this.myFormInfo.tabList && this.myFormInfo.tabList.forEach(tab=>{
                    const newTab = {
                        text:tab.text,
                        components:[]
                    }

                    tab.components.forEach(component=>{
                        if(!['gridtable'].includes(component.type)){
                            if(!component.display){
                                hideComponents.push(component)
                            }
                            else if(authMap[component.prop]){
                                if(authMap[component.prop] != '2'){
                                    component.disabled = true
                                    //component.readonly = true
                                }
                                newTab.components.push(component)
                            }
                            else if(['guid','company','department','createuser','modifyuser','createtime','modifytime',''].includes(component.type)){
                                component.display = false
                                hideComponents.push(component)
                            }
                        }
                        else{

                            if(authMap[`${component.prop}_add`] ){
                                if(authMap[`${component.prop}_add`] == '2'){
                                    component.isAddBtn = true
                                }
                                else{
                                    component.isAddBtn = false
                                }
                            }

                            if(authMap[`${component.prop}_remove`] ){
                                if(authMap[`${component.prop}_remove`] == '2'){
                                    component.isRemoveBtn = true
                                }
                                else{
                                    component.isRemoveBtn = false
                                }
                            }

                            if(authMap[component.prop]){
                                newTab.components.push(component)
                                component.children.forEach((cell)=>{
                                    if(authMap[component.prop][cell.prop]){
                                        if(authMap[component.prop][cell.prop] != '2'){
                                            cell.disabled = true
                                            //cell.readonly = true
                                        }
                                    }
                                    else {
                                        cell.display = false
                                    }
                                })
                            }
                        }
                    })
                    // 不可见的组件单独放置

                    if(newTab.components.length > 0){
                        tabList.push(newTab)
                    }
                })

                if(tabList.length >0){
                    tabList[0].components.push(...hideComponents)
                }


                return tabList
            }
            else if( this.isWfForm ){ // 表单的流程权限
                const tabList = []

                // 放置隐藏组件
                const hideComponents = []

                this.myFormInfo.tabList && this.myFormInfo.tabList.forEach(tab=>{
                    const newTab = {
                        text:tab.text,
                        components:[]
                    }

                    tab.components.forEach(component=>{
                        if(!['gridtable'].includes(component.type)){
                            if(!component.display){
                                hideComponents.push(component)
                            }
                            else if(this.authFieldsMap[component.prop] && (this.authFieldsMap[component.prop].isEdit || this.authFieldsMap[component.prop].isLook) ){
                                if(!this.authFieldsMap[component.prop].isEdit){
                                    component.disabled = true
                                }
                                newTab.components.push(component)
                            }
                            else if(['guid','company','department','createuser','modifyuser','createtime','modifytime',''].includes(component.type)){
                                component.display = false
                                hideComponents.push(component)
                            }
                        }
                        else{
                            if(this.authFieldsMap[`${component.prop}_add`] ){
                                if(this.authFieldsMap[`${component.prop}_add`].isEdit){
                                    component.isAddBtn = true
                                }
                                else{
                                    component.isAddBtn = false
                                }
                            }

                            if(this.authFieldsMap[`${component.prop}_remove`] ){
                                if(this.authFieldsMap[`${component.prop}_remove`].isEdit){
                                    component.isRemoveBtn = true
                                }
                                else{
                                    component.isRemoveBtn = false
                                }
                            }

                            if(this.authFieldsMap[`${component.prop}_required`] ){
                                if(this.authFieldsMap[`${component.prop}_required`].required){
                                    component.required = true
                                }
                                else{
                                    component.required = false
                                }
                            }

                            
                            

                            component.children.forEach((cell)=>{
                                if(this.authFieldsMap[cell.prop] && (this.authFieldsMap[cell.prop].isEdit || this.authFieldsMap[cell.prop].isLook)){
                                    if(!this.authFieldsMap[cell.prop].isEdit){
                                        cell.disabled = true
                                    }
                                    if(newTab.components.findIndex(t=>t.prop == component.prop) == -1){
                                        newTab.components.push(component)
                                    }
                                }
                                else {
                                    cell.display = false
                                }
                            })
                        }
                    })
                    // 不可见的组件单独放置

                    if(newTab.components.length > 0){
                        tabList.push(newTab)
                    }
                })

                if(tabList.length >0){
                    tabList[0].components.push(...hideComponents)
                }


                return tabList


            }
            else {
                return this.myFormInfo.tabList || []
            }
        },
        showTabList(){
            if(this.isRead){
                const tabList = this.$deepClone(this.tabList)
                tabList.forEach(tab=>{
                    tab.components.forEach(component=>{
                        if(!['gridtable'].includes(component.type)){
                            component.disabled = true
                        }
                        else{
                            component.isAddBtn = false
                            component.isRemoveBtn = false
                            component.children.forEach((cell)=>{
                                cell.disabled = true
                            })
                        }
                    })
                })
                return tabList
            }
            return this.tabList

        },
        gridtables(){
            const res = []
            this.myFormInfo.tabList.forEach(tab=>{
                tab.components.forEach(component=>{
                    if(['gridtable'].includes(component.type)){
                        res.push(component)
                    }
                })
            })
            console.log(res)
            return res
        },
        components(){
            const res ={}
            this.myFormInfo.tabList && this.myFormInfo.tabList.forEach(tab=>{
                tab.components.forEach(component=>{
                    if(!['gridtable'].includes(component.type)){
                        res[component.prop] = component
                    }
                    else{
                        res[component.prop] = component
                        component.children.forEach(col=>{
                             res[col.prop] = col
                        })
                    }
                })
            })

            return res
        }
    },
    mounted () {
    },
    watch:{
        formInfo:{
            handler(){
                this.resetFormData()
            },
            deep: true,
            immediate: true
        }
    },
    methods:{ 
        resetFormData(){
            this.oldFormData = null
            this.myFormInfo = this.$deepClone(this.formInfo)

            this.myFormInfo.tabList && this.myFormInfo.tabList.forEach(tab=>{
                tab.components.forEach(component=>{
                    if(['guid','company','department','createuser','modifyuser','createtime','modifytime','encode'].includes(component.type)){
                        this.$set(this.formData,component.prop,'')
                    }
                    else if(['switch'].includes(component.type)){
                        this.$set(this.formData,component.prop,this.toValueType(component.valueType,component.default) || this.toValueType(component.valueType,component.inactiveValue))
                    }
                    /*else if(['rate','slider'].includes(component.type)){
                        this.$set(this.formData,component.prop,component.default || undefined)
                    }*/
                    else if(['gridtable'].includes(component.type)){
                        this.$set(this.formData,component.prop,this.$deepClone(component.dataSource))
                    }
                    else if(!['viewtable'].includes(component.type)){
                        if(this.formData[component.prop] != component.default){
                            this.$set(this.formData,component.prop,component.default)
                        }
                    }
                })
            })
            this.$nextTick(()=>{
                this.formActiveName = 'tab0'
                this.$refs.form.clearValidate()
            })
        },  
        getTableColumns(children){
            const columns = []
            children.forEach(col=>{
                columns.push({id:col.prop,isHidden:!col.display,prop:col.prop,label:col.label,width:col.labelWidth,required:col.required,patterns:col.patterns})
            })
            return columns
        },
        toValueType(type,value){
            if(!this.$validatenull(value) && !this.$validatenull(type)){
                switch(type){
                    case 'boolean':
                        return value == 'true'
                    case 'string':
                        return value
                    case 'number':
                        return Number(value)
                }
            }
        },
        handleAddRow(myTable){
            let point = {}
            myTable.children.forEach(col => {
                if(!['guid'].includes(col.type)){
                    point[col.prop] = col.default || '';
                }
                else{
                    point[col.prop] = '';
                }
                
                if(!col.display){
                    switch(col.type){
                        case 'guid':
                            point[col.prop] = this.$uuid()
                            break
                        case 'company':
                            point[col.prop] = this.userCompanyId
                            break
                        case 'department':
                            point[col.prop] = this.userDepartmentId
                            break
                        case 'createuser':
                            point[col.prop] = this.userId
                            break
                        case 'modifyuser':
                            point[col.prop] = this.userId
                            break
                        case 'createtime':
                            point[col.prop] = this.$getDayTime()
                            break
                        case 'modifytime':
                            point[col.prop] = this.$getDayTime()
                            break
                    }
                }

            });
            this.formData[myTable.prop].push(point)
        },
        handleDeleteRow(event,myTable){
            this.formData[myTable.prop].splice(event.index,1);
        },
        validateForm(){
            return new Promise((resolve) => {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        const gridtables = this.gridtables
                        let gridValid = true
                        gridtables.forEach(item=>{
                            gridValid = this.$refs[item.prop][0].validate()
                            if(!gridValid){
                                return gridValid
                            }
                        })

                        if(gridValid){
                            // 脚本
                            const {res,fn} = this.$getFunction(this.myFormInfo.afterValidateForm)
                            if(res){
                                gridValid = await fn({formData:this.getForm(),httpGet:this.httpGet})
                                console.log(gridValid,'gridValid')
                            }
                        }

                        resolve(gridValid)
                    }
                    else {
                        resolve(false)
                    }
                })
            })
        },
        getForm(){
            // 获取表单数据
            return this.$deepClone(this.formData)
        },

        setForm(data){
            


            const _formData = {}

            // 设置表单数据
            this.myFormInfo.tabList && this.myFormInfo.tabList.forEach(tab=>{
                tab.components.forEach(component=>{
                    if(['gridtable'].includes(component.type)){
                        _formData[component.prop] = this.getTableData(component,data)
                    }
                    else if(!['viewtable'].includes(component.type)){
                        const v = this.getDataValue(component,data)
                        v && (_formData[component.prop] = v)
                    }
                })
            })

                        // 脚本
            const {res,fn} = this.$getFunction(this.myFormInfo.beforeSetData)
            if(res){
                fn({formData:_formData,setRequired:this.setRequired,setDisabled:this.setDisabled})
            }


            this.formData = _formData
            this.oldFormData = this.$deepClone(this.formData)// 复制一份表单数据用来做后续比对
        },
        getDataValue(component,data){
           if(data[component.table] && data[component.table][0] ) {
               return data[component.table][0][component.field.toLowerCase()]
           }
           else{
               return
           }
        },
        getTableData(component,data){
            const dataTable = data[component.table] || []
            const res = []
            dataTable.forEach((row)=>{
                const rowTmp = {}
                component.children.forEach((cell)=>{
                    if(row[cell.field.toLowerCase()]){
                        rowTmp[cell.prop] = row[cell.field.toLowerCase()]
                    }
                })
                res.push(rowTmp)
            })

            return res

           

        },


        setRequired(prop,isRequired = true){
            const  component = this.components[prop]
            if(component){
                this.$set(component,'required',isRequired)
                this.$set(this.myFormInfo.tabList[0] ,0,this.myFormInfo.tabList[0])
            }
        },

        setDisabled(prop,isDisabled = true){
            const  component = this.components[prop]
            if(component){
                this.$set(component,'disabled',isDisabled)
                this.$set(this.myFormInfo.tabList[0],0,this.myFormInfo.tabList[0])
            }
        },
        httpGet(url,params){
            window.$axios({
                url: `${url}`,
                method: 'get',
                params
            })
    
        },

        // 比对数据修改
        getDiffFormData() {
            const diffFormData = []
           
            if(this.oldFormData == null){
                return diffFormData
            }
            for (var key in this.oldFormData) {
                const componentM = this.components[key]

                if(componentM && !['gridtable','divider','upload','uploadimg','company',
                'department','createuser','modifyuser','createtime','modifytime','viewtable'].includes(componentM.type)
                && this.oldFormData[key] != this.formData[key]){
                    const dataPoint = { // 数据变动
                        table_Name: componentM.table,
                        tableField: componentM.field,
                        formColumn: componentM.label,
                        oldVal: this.oldFormData[key],
                        newVal: this.formData[key],
                        oldShowVal: '',
                        newShowVal: '',
                        creator:this.loginInfo.f_RealName+'/'+this.loginInfo.f_Account
                    }
                    dataPoint.oldShowVal = this.getShowText(key,this.oldFormData)
                    dataPoint.newShowVal = this.getShowText(key,this.formData)

                    diffFormData.push(dataPoint)
                }
            }
            return diffFormData
        },
        findTreeItem(arr, res) {
            arr.forEach(t=>{
                res.push({value:t.value,label:t.label})
                if(t.children){
                    this.findTreeItem(t.children,res)
                }
            })
        },

        getShowText(id,formData){
            if(formData == null)
            {
                formData = this.formData
            }
            const v = formData[id]


            const componentM = this.components[id]
            switch(componentM.type){
                case "radio":
                case "select":            
                case "treeselect":
                case "layerselect": 
                case "checkbox":
                case "selectMultiple":
                    if (componentM.dataType == "3") {
                        if (componentM.upCtrl) {
                            if(formData && formData[componentM.upCtrl]){
                                const upCtrlVal = formData[componentM.upCtrl]
                                return this.lr_dataSourceName(this.lr_dataSourceDataByParamter[`${componentM.dataCode}_${upCtrlVal}`] ,v,componentM.dataValueKey,componentM.dataLabelKey)
                            }
                        }
                        else{
                            return this.lr_dataSourceName(this.lr_dataSourceData[componentM.dataCode],v,componentM.dataValueKey,componentM.dataLabelKey)
                        }
                    }
                    else if (componentM.dataType == "2"){
                        return this.lr_dataItemName(this.lr_dataItem[componentM.dataCode],v)
                    }
                    else {
                        const dataSource = []
                        this.findTreeItem(componentM.options,dataSource)  //静态数据
                        return this.lr_dataSourceName(dataSource,v,'value','label')
                    }
                    break
                case "companySelect":
                    return this.lr_loadCompanyName(v)
                case "departmentSelect":
                    return this.lr_departmentNameByOne(v)
                case "userSelect":
                    return this.lr_userName(v)
                case "areaselect":
                    return this.lr_areasName(v)
            }
            return v
        },

        filterTableDeleteBtn(row){
            if(row.hasNoDeleteBtn){
                return false
            }
            else{
                return true
            }
        }
    }
}
</script>

<style lang="less">
@import './index.less';
</style>